import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { ClassDirective } from '@ngbracket/ngx-layout/extended';

@Component({
  selector: 'bt-spinner-overlay',
  templateUrl: './spinner-overlay.component.html',
  styleUrls: ['./spinner-overlay.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [ClassDirective, MatProgressSpinner, NgClass]
})
export class SpinnerOverlayComponent {
  @Input() opaque = false;
}
